(function () {
var header;
var spacer;
var menu;
var button;
var overlay;
var resizeObserver;
function getElements() {
header = document.querySelector('[data-scnt-header]');
spacer = document.querySelector('.scnt-header-spacer');
menu = document.getElementById('scnt-mobile-nav');
button = document.querySelector('.scnt-mobile-menu-button');
overlay = document.querySelector('[data-scnt-menu-overlay]');
}
function updateHeaderHeight() {
if (!header) {
return;
}
var height = Math.ceil(
header.getBoundingClientRect().height
);
document.documentElement.style.setProperty(
'--scnt-header-height',
height + 'px'
);
document.documentElement.style.setProperty(
'--scnt-visible-header-height',
height + 'px'
);
if (spacer) {
spacer.style.height = height + 'px';
}
}
function setMenuState(open) {
if (!menu || !button) {
return;
}
menu.classList.toggle('is-open', open);
button.classList.toggle('is-active', open);
button.setAttribute(
'aria-expanded',
open ? 'true' : 'false'
);
button.setAttribute(
'aria-label',
open
? 'Close navigation menu'
: 'Open navigation menu'
);
menu.setAttribute(
'aria-hidden',
open ? 'false' : 'true'
);
document.body.classList.toggle(
'scnt-menu-open',
open
);
}
function toggleMenu() {
if (!menu) {
return;
}
setMenuState(
!menu.classList.contains('is-open')
);
}
function closeMenu() {
setMenuState(false);
}
function initialiseHeader() {
getElements();
if (!header) {
return;
}
updateHeaderHeight();
if (button && !button.dataset.scntBound) {
button.addEventListener('click', function (event) {
event.preventDefault();
event.stopPropagation();
toggleMenu();
});
button.dataset.scntBound = 'true';
}
if (overlay && !overlay.dataset.scntBound) {
overlay.addEventListener('click', closeMenu);
overlay.dataset.scntBound = 'true';
}
if (menu && !menu.dataset.scntBound) {
menu.querySelectorAll('a').forEach(function (link) {
link.addEventListener('click', closeMenu);
});
menu.dataset.scntBound = 'true';
}
if (
window.ResizeObserver &&
!resizeObserver
) {
resizeObserver = new ResizeObserver(function () {
updateHeaderHeight();
});
resizeObserver.observe(header);
}
}
document.addEventListener('click', function (event) {
if (
header &&
menu &&
menu.classList.contains('is-open') &&
!header.contains(event.target)
) {
closeMenu();
}
});
document.addEventListener('keydown', function (event) {
if (event.key === 'Escape') {
closeMenu();
if (button) {
button.focus();
}
}
});
window.addEventListener('resize', function () {
updateHeaderHeight();
if (window.innerWidth > 900) {
closeMenu();
}
});
document.addEventListener(
'DOMContentLoaded',
initialiseHeader
);
document.addEventListener(
'shopify:section:load',
initialiseHeader
);
document.addEventListener(
'shopify:section:reorder',
initialiseHeader
);
initialiseHeader();
})();